import $ from 'jquery';

const posts = {

  init() {
    posts.titleHoverState();
    return posts;
  },

  // set hover state on title if hovering over thumbnail and vice versa
  titleHoverState() {
    const titleClass = '.title-page';
    const titleThumnailClass = '.next-to-title-page';
    const titles = $(titleClass);
    const titleThumbnails = $(titleThumnailClass);

    titles.each((_index, el) => {
      const thisTitle = $(el);
      thisTitle.hover(
        // @TODO SEE IF WE NEED TO USE ev.currentTarget instead of EL
        (_ev) => $(el).siblings(titleThumnailClass).children('a').addClass('hover'),
        (_ev) => $(el).siblings(titleThumnailClass).children('a').removeClass('hover'),
      );
    });
    titleThumbnails.each((_index, el) => {
      const thisTitleThumbnail = $(el);
      thisTitleThumbnail.hover(
        // @TODO SEE IF WE NEED TO USE ev.currentTarget instead of EL
        (_ev) => $(el).siblings(titleClass).children('a').addClass('hover'),
        (_ev) => $(el).siblings(titleClass).children('a').removeClass('hover'),
      );
    });
  },
};
export default posts;
